class VariantRadiosProductSingle extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.bls__option-swatch').forEach(button => {
      button.addEventListener(
        'click',
        this.onVariantChange.bind(this),
        false
      );
    });

    this.collectOptions();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.renderProductInfo();
    this.actionDropdownSwatches();
  }

  /* =========================
    EVENT HANDLER
  ========================== */
  onVariantChange(event) {
    event.preventDefault();

    const target = event.currentTarget;
    const value = target.dataset.value;

    // set active state
    target
      .closest('.product-form__input')
      .querySelectorAll('.bls__option-swatch')
      .forEach(item => item.classList.remove('active'));

    target.classList.add('active');

    const selectedValue = target
      .closest('.product-form__input')
      .querySelector('.swatch-selected-value');

    if (selectedValue) selectedValue.textContent = value;

    // core flow
    this.collectOptions();
    this.updateMasterId();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, window.variantStrings.unavailable);
      this.setUnavailable();
      return;
    }

    this.updateVariantInput();
    this.renderProductInfo();
  }

  /* =========================
    OPTION & VARIANT CORE
  ========================== */
  collectOptions() {
    this.options = [];
    this.querySelectorAll('.product-form__input').forEach((fieldset, index) => {
      const active = fieldset.querySelector('.bls__option-swatch.active');
      this.options[index] = active ? active.dataset.value : null;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant =>
      variant.options.every((option, index) => option === this.options[index])
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );

    productForms.forEach(form => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* =========================
    AVAILABILITY LOGIC
  ========================== */
  updateVariantStatuses() {
    const variants = this.getVariantData();
    const fieldsets = [...this.querySelectorAll('.product-form__input')];

    fieldsets.forEach((fieldset, index) => {
      if (index === 0) return;

      const prevValue = this.options[index - 1];
      if (!prevValue) return;

      const availableValues = variants
        .filter(v => v.available && v.options[index - 1] === prevValue)
        .map(v => v.options[index]);

      fieldset.querySelectorAll('.bls__option-swatch').forEach(swatch => {
        if (availableValues.includes(swatch.dataset.value)) {
          swatch.removeAttribute('data-disabled');
        } else {
          swatch.setAttribute('data-disabled', 'disabled');
        }
      });
    });
  }

  /* =========================
    UI RENDER
  ========================== */
  renderProductInfo() {
    if (!this.currentVariant) return;

    const form = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const product = form.closest('.bls__product-single');

    const price = this.currentVariant.price;
    const compare = this.currentVariant.compare_at_price;
    const available = this.currentVariant.available;

    const priceWrapper = product.querySelector('.bls__price');
    if (priceWrapper) {
      const priceEl = priceWrapper.querySelector('.price__regular .price');

      priceEl.innerHTML = Shopify.formatMoney(
        price,
        cartStrings.money_format
      );

      priceWrapper.classList.remove('price--sold-out', 'price--on-sale');
      priceEl.classList.remove('special-price');

      if (compare && compare > price) {
        const compareEl = priceWrapper.querySelector('.compare-price');
        if (compareEl) {
          compareEl.innerHTML = Shopify.formatMoney(
            compare,
            cartStrings.money_format
          );
        }
        priceWrapper.classList.add('price--on-sale');
        priceEl.classList.add('special-price');
      } else if (!available) {
        priceWrapper.classList.add('price--sold-out');
      } 
    }

    const availabilityText = available
      ? window.variantStrings.inStock
      : window.variantStrings.outStock;

    const availabilityEl = product.querySelector('.bls__availability-value');
    if (availabilityEl) availabilityEl.textContent = availabilityText;

    this.toggleAddButton(!available, available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut
    );

    if (this.currentVariant.featured_media) {
      setTimeout(() => {
        const img = product.querySelector('.bls__product-main-img img');
        if (!img) return;
        img.removeAttribute('srcset');
        img.src = this.currentVariant.featured_media.preview_image.src;
      }, 300);
    }

    const skuEl = product.querySelector('.bls__product-sku-value');
    if (skuEl) {
      skuEl.textContent =
        this.currentVariant.sku && this.currentVariant.sku !== ''
          ? this.currentVariant.sku
          : 'N/A';
    }
  }

  toggleAddButton(disable, text) {
    const form = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!form) return;

    const button = form.querySelector('[name="add"]');
    const buttonText = form.querySelector('[name="add"] > span');

    if (!button) return;

    if (disable) {
      button.setAttribute('disabled', 'disabled');
    } else {
      button.removeAttribute('disabled');
    }

    if (buttonText && text) buttonText.textContent = text;
  }

  setUnavailable() {
    const form = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const buttonText = form?.querySelector('[name="add"] > span');
    if (buttonText) {
      buttonText.textContent = window.variantStrings.unavailable;
    }
  }

  /* =========================
    DATA
  ========================== */
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  /* =========================
    DROPDOWN SWATCH (GIỮ NGUYÊN)
  ========================== */
  actionDropdownSwatches() {
    this.querySelectorAll('[data-swatches-value]').forEach(items => {
      items.addEventListener('click', e => {
        const dropdown = e.currentTarget.closest('.bls__color-dropdown');
        if (!dropdown) return;
        document
          .querySelectorAll('.bls__color-dropdown')
          .forEach(el => el.classList.remove('isClicked'));
        dropdown.classList.toggle('isClicked');
      });
    });

    this.querySelectorAll('.bls__product-color-swatches-dropdown').forEach(
      swatch => {
        swatch.addEventListener('click', e => {
          const target = e.currentTarget;
          const value = target.dataset.value;
          const dropdown = target.closest('.bls__color-dropdown');
          dropdown.querySelector(
            '.bls__color-dropdown-value'
          ).innerHTML = value;
          dropdown.classList.remove('isClicked');
        });
      }
    );
  }
}

customElements.define(
  'variant-radios-product-single',
  VariantRadiosProductSingle
);


var BlsEventGroup = (function () {
    return {
        init: function() {
        this.eventProductGroup();
        this.showPopupStockNotify();
        },
        eventProductGroup: function() {
            var group = document.querySelector('.productGroup[type="application/json"]');
            if (!group) return;
            var variantData = JSON.parse(group.innerText);
            var query = '';
            variantData.forEach((e, key, variantData) => {
                if (!Object.is(variantData.length - 1, key)) {
                    query += e+'%20OR%20id:';
                }
                else{
                    query += e;
                }
            });
            var productAjaxURL = "?q=id:" + query+'&section_id=product-grouped';
            fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then(response => response.text())
            .then(async (responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                document.getElementById('bls__product-group').innerHTML = html.querySelector('.bls__product-group').innerHTML;
            }).catch((e) => {
                throw error;
            }).finally(() => {
                this.eventProductGroupAction()
                BlsLazyloadImg.init();
            });
        },
        
        eventProductGroupAction: function() {
            document.querySelectorAll('#bls__product-group .product-variant-option').forEach(select => {
                select.addEventListener("change", (event) => {
                    var target = event.target;
                    var
                        image = target.options[target.selectedIndex].getAttribute('data-image'),
                        price = target.options[target.selectedIndex].getAttribute('data-price'),
                        pro_handle = target.getAttribute('data-handle'),
                        compare_price = target.options[target.selectedIndex].getAttribute('data-compare-price');
                    var img = target.closest('#bls__product-group').querySelector('.product-group-image-item.'+pro_handle+'').querySelector('img');
                    if ( img ) {
                        img.removeAttribute('srcset');
                        img.setAttribute('src', image);
                    }
                    var info_price = target.closest('.product-group-item').querySelector('.info-price');
                    info_price.querySelector('.price__regular .price').innerHTML = Shopify.formatMoney(price, cartStrings.money_format);
                    const bls__price = info_price.querySelector('.bls__price');
                    bls__price.classList.remove('price--sold-out', 'price--on-sale');
                    bls__price.querySelector('.price__regular .price').classList.remove('special-price');
                    if (compare_price && compare_price > price) {
                        const compare_format = Shopify.formatMoney(compare_price, cartStrings.money_format)
                        if (bls__price.querySelector('.compare-price')) {
                            bls__price.querySelector('.compare-price').innerHTML = compare_format;
                        }
                        bls__price.classList.add('price--on-sale');
                        bls__price.querySelector('.price__regular .price').classList.add('special-price');
                    }
                    target.setAttribute('data-price', price);
                    target.setAttribute('data-compare-price', compare_price);
                }, false);
            });

            let totalQty = 0;
            const classQty = document.querySelectorAll('.quantity__input-product-group')
            classQty.forEach(input => {
                let valueQtyDefault = input.value
                let valueAsDefault = parseFloat(valueQtyDefault);
                if (!isNaN(valueAsDefault)) {
                    totalQty += valueAsDefault
                }
                input.addEventListener('change', () => {
                    totalQty = 0;
                    classQty.forEach(value => {
                        let valueQty = value.value
                        let valueAsQty = parseFloat(valueQty);
                        if (!isNaN(valueAsQty)) {
                            totalQty += valueAsQty
                        }
                    })
                })
            });
            document.querySelectorAll('.product-group-submit').forEach(
                (button) => {
                    button.addEventListener('click', 
                        (event) => {
                            if (totalQty === 0) {
                                const content = document.querySelector(".form-infor .add-cart-error");
                                const messageErrQty = button.getAttribute('data-add-cart-err-qty');
                                if (!content) return;
                                var error_message = EasyDialogBox.create(
                                    "add_cart_error",
                                    "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                                    "",
                                    content.innerHTML = messageErrQty
                                );
                                error_message.onClose = error_message.destroy;
                                error_message.show();
                            } else {
                                this.submitProductGroup(event)
                            }
                        }
                    , false)
                }
            );

            document.querySelectorAll('.product-group-buy-now').forEach(
                (button) => {
                    button.addEventListener('click', 
                        (event) => {
                            if (totalQty === 0) {
                                const content = document.querySelector(".form-infor .add-cart-error");
                                const messageErrQty = button.getAttribute('data-add-cart-err-qty');
                                if (!content) return;
                                var error_message = EasyDialogBox.create(
                                    "add_cart_error",
                                    "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                                    "",
                                    content.innerHTML = messageErrQty
                                );
                                error_message.onClose = error_message.destroy;
                                error_message.show();
                            } else {
                                this.submitNowProductGroup(event)
                            }
                        }
                    , false)
                }
            );
        },

        submitProductGroup: function(event) {
            event.preventDefault();
            const target = event.currentTarget;
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const form = document.getElementById('form-product-grouped');
            const config = fetchConfig('json');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            let openMiniCart = 0
            const formData = new FormData(form);
            if (cart) {
                formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
            }
            config.body = formData;
            target.classList.add('btn-loading');
            fetch(`${routes.cart_add_url}.js`, config)
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    fetch('/cart.json')
                        .then(res => res.json())
                        .then(cart => {
                            document.querySelectorAll(".cart-count").forEach(el => {
                                if (el.classList.contains('cart-count-drawer')) {
                                    el.innerHTML = `(${cart.item_count})`;
                                    }else{
                                    el.innerHTML = cart.item_count;
                                    }
                            });
                            const cart_free_ship = document.querySelector("free-ship-progress-bar");
                            if (cart_free_ship) {
                                cart_free_ship.init(cart.items_subtotal_price);
                            }
                        })
                        .catch((error) => {
                            throw error;
                        });
                    const parsedState = JSON.parse(state);
                    if (parsedState.message) {
                        const content = document.querySelector(".form-infor .add-cart-error");
                        if (!content) return;
                        var error_message = EasyDialogBox.create(
                            "add_cart_error",
                            "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                            "",
                            content.innerHTML = parsedState.description
                        );
                        error_message.onClose = error_message.destroy;
                        error_message.show();
                    } else {
                        openMiniCart = 1
                        cart.getSectionsToRender().forEach((section => {
                            const elementToReplace = document.getElementById(section.id);
                            const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
                            elementToReplace.innerHTML = html.querySelector('#form-mini-cart').innerHTML;
                            const countdown = cart.querySelector('.cart-countdown-time');
                            const html_countdown = html.querySelector('.cart-countdown-time');
                            if (countdown && html_countdown) {
                                countdown.innerHTML = html_countdown.innerHTML;
                                cart.countdownTimer();
                            }
                        }));
                        cart.cartAction();
                    }
                })
                .catch((e) => {
                    throw e;
                })
                .finally(() => {
                    target.classList.remove('btn-loading');
                    if (openMiniCart === 1) {
                        cart.open();
                    }
                    BlsLazyloadImg.init();
                });
        },

        submitNowProductGroup: function(event) {
            event.preventDefault();
            const form = document.getElementById('form-product-grouped');
            const config = fetchConfig('json');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            const formData = new FormData(form);
            config.body = formData;
            fetch(`${routes.cart_add_url}.js`, config)
                .then((response) => {
                    return response.text();
                })
                .then((state) => {
                    const parsedState = JSON.parse(state);
                    if (parsedState.items) {
                        window.location.href = "/checkout";
                    }else{
                        const content = document.querySelector(".form-infor .add-cart-error");
                        if (!content) return;
                        var error_message = EasyDialogBox.create(
                            "add_cart_error",
                            "dlg dlg-disable-footer dlg-disable-drag dlg-disable-heading",
                            "",
                            content.innerHTML = parsedState.description
                        );
                        error_message.onClose = error_message.destroy;
                        error_message.show();
                    }
                })
                .catch((e) => {
                    throw e;
                })
        },

        showPopupStockNotify: function () {
            const stockClass = document.querySelectorAll(".product-notify-stock");
            const _this = this;
            stockClass.forEach(stock => {
                stock.addEventListener("click", (e) => {
                    const target = e.currentTarget;
                    const variantId = target.getAttribute('data-product-variant')
                    e.preventDefault();
                    _this.fetchDataStockNotifySection(variantId);
                    });
            })
          },

        fetchDataStockNotifySection: function(variantId) {
            const url = "/variants/"+variantId+"/?section_id=stock-notify";
            fetch(url)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = newParser.parseFromString(responseText, "text/html");
                    const id = html.querySelector("#bls-stock-notify");
                    const text = id.getAttribute('data-stock-title')
                    if (id) {
                        var createPopupStock = EasyDialogBox.create('stockNotify', 'dlg dlg-disable-footer dlg-disable-drag', text, id.innerHTML);
                        createPopupStock.onClose = createPopupStock.destroy;
                        createPopupStock.show();
                    }
                })
                .catch((e) => {
                throw e;
                });
        }
    }
  })();
BlsEventGroup.init();
